import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoBolletteStep2Component } from './conservazione-carica-documento-bollette-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-bollette-step2', {
            url: '/conservazione-carica-bollette',
            ncyBreadcrumb: {
                label: 'Carica Bollette',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-bollette-step2 flex="100"></conservazione-carica-documento-bollette-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoBolletteStep2Module: string = ng
    .module('conservazione-carica-documento-bollette-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoBolletteStep2', ConservazioneCaricaDocumentoBolletteStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-bollette-step2/conservazione-carica-documento-bollette-step2.module.ts